import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: "shop-list",
  name: "文创商品",
  icon: "店",
  group: "国学组件",
  description: "展示文创商品、课程商品和服务套餐。",
  defaultProps: {
    "title": "文创商城",
    "limit": 6
}
}
